//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
//Components
import { breadCrumbItems } from '../../utils/spaConstants';
import ServicesFilter from './../SpaServices/ServicesFilter';
import { SpaLayout } from './SpaLayout';
//Assests
import '../../css/services.css';
//Actions
import {
    servicesFetchData, filterByServiceByCategory, showFilteredServices,
    setSelectedDate, setCruiseDates, filterByBenfit, resetFilter, selectService,
    filterByDuration, sortAvailableServices, selectGuest, selectTimeSlot, getItinerary
} from '../../actions/spaServices.actions';



class SpaServices extends Component {

    constructor(props) {
        super(props);
        this.actions = this.props.actions;
        this.onFilterButtonClick = this.onFilterButtonClick.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // eslint-disable-next-line no-undef
        this.props.actions.fetchData();
        document.title = "Browse Spa Services";
    }

    onFilterButtonClick() {
        this.props.actions.showFilteredServices(true);
    }


    render() {
        let { actions } = this;
        let { services = {}, reservations = {} } = this.props;
        let { authDetails = {} } = services;
        let { cart = [] } = reservations;
        let { appTrigger = 'CP' } = authDetails;
        return (
            <div>
                <main id="container">
                    <div className="spa-content white-bg-tint  spa-font-family cp-border-radius">
                        <SpaLayout cart={cart} items={breadCrumbItems.services} appTrigger={appTrigger}>
                            <Container fluid={true} style={{ 'padding': '0' }} className='services-container'>
                                <h1 className='visuallyhidden'>Browse Spa Services</h1>
                                <ServicesFilter onFilterButtonClick={this.onFilterButtonClick.bind(this)} actions={actions} services={services} />
                            </Container>
                        </SpaLayout>
                    </div>
                </main>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        services: state.services,
        reservations: state.reservations,
    };
};
const mapDispatchToProps = (dispatch) => {

    const ServicesActions = {
        fetchData: (url) => dispatch(servicesFetchData()),
        filterByServiceByCategory: (category) => dispatch(filterByServiceByCategory(category)),
        showFilteredServices: (isShow) => dispatch(showFilteredServices(isShow)),
        setSelectedDate: (selectedDate, formatedDate, reqdate) => dispatch(setSelectedDate(selectedDate, formatedDate, reqdate)),
        setCruiseDates: (cruiseStartDate, cruiseEndDate) => dispatch(setCruiseDates(cruiseStartDate, cruiseEndDate)),
        filterByBenfit: (banefit) => dispatch(filterByBenfit(banefit)),
        resetFilter: (filterType) => dispatch(resetFilter(filterType)),
        filterByDuration: (selectedDuration, selectedSort) => dispatch(filterByDuration(selectedDuration, selectedSort)),
        sortAvailableServices: (selectedSort) => dispatch(sortAvailableServices(selectedSort)),
        selectGuest: (selectedGuest) => dispatch(selectGuest(selectedGuest)),
        selectTimeSlot: (selectedTimeSlot) => dispatch(selectTimeSlot(selectedTimeSlot)),
        selectService: (slectedService) => dispatch(selectService(slectedService)),
        getItinerary: () => dispatch(getItinerary())
    };

    return {
        actions: ServicesActions
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SpaServices);